import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useEffect } from 'react';

export default function BasicTabsLeve({handleTabs,isLog=false}) {
  const [value, setValue] = React.useState(1);
  useEffect(()=>{

    handleTabs(1)

  },[])


  const handleChange = (event, newValue) => {
    setValue(newValue);

    //const res = syms.filter(sym=>parseFloat(sym.buy) === 1)

      handleTabs(newValue)

  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        maxWidth: { xs: 320, sm: 480 },
        bgcolor: 'background.paper',
      }}
    >
      {isLog?

              <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              >

        <Tab label="همه ارزها"  />
        <Tab label="پرسودترین"  />
        <Tab label="ضریب 3" />
        <Tab label="ضریب 5" />


          </Tabs>


      :


      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >

        <Tab label="همه ارزها"  />
        <Tab label="پرسودترین"  />
        <Tab label="ضریب 3" />
        <Tab label="ضریب 5" />


        
      </Tabs>
      }


    </Box>
  );
}
